export const deepLinkAssets = {
	rewarding: {
		success: {
			portrait: "/spec_deep_link/success-background.png",
			landscape: "/spec_deep_link/success-background-landscape.png"
		},
		alreadyClaimed: {
			portrait: "/spec_deep_link/already-claimed-background.png",
			landscape: "/spec_deep_link/already-claimed-background-landscape.png"
		},
		error: {
			portrait: "/spec_deep_link/oops-background.png",
			landscape: "/spec_deep_link/oops-background-landscape.png"
		}
	}
} as const;
